const profileReducer = (state = [], action) => {
    let { type, payload } = action;
    switch (type) {
        case "ADD_PROFILE":
            return payload;
        default:
            return state;
    }
};

export default profileReducer;
